import { createAction, props } from '@ngrx/store';
import { PostOfferFacilityBillingInformationPayload } from '../models/perm-post-offer-facility-billing-information-payload.model';
import { PostOfferRemovalReasonsPayload } from '../models/perm-post-offer-removal-reasons.model';
import { PostOfferJobInformationPayload } from '../models/perm-post-offer-job-information-payload.model';
import { PostOfferInformationSerializable } from '../models/perm-post-offer-information.model';
import { PostOfferModalLoadPayload } from '../models/perm-post-offer-modal-load-payload.model';
import { ClosePostOfferModalPayload } from '../models/close-post-offer-modal-payload.model';

export const loadPostOfferModal = createAction(
    '[Perm Offer Effect] Load Post Offer Modal',
    props<PostOfferModalLoadPayload>()
);

export const closePostOfferModal = createAction(
    '[Perm Offer Effect] Close Post Offer Modal',
    props<ClosePostOfferModalPayload>()
);

export const fetchPermBillingInformationSuccess = createAction(
    '[Perm Offer Effect] Fetch Perm Billing Information Success',
    props<PostOfferFacilityBillingInformationPayload>()
);

export const fetchPermBillingInformationFailure = createAction(
    '[Perm Offer Effect] Fetch Perm Billing Information Failure'
);

export const fetchPermOfferDeclinedRemovalReasonsSuccess = createAction(
    '[Perm Offer Effect] Fetch Perm Offer Declined Removal Reasons Success',
    props<PostOfferRemovalReasonsPayload>()
);

export const fetchPermOfferDeclinedRemovalReasonsFailure = createAction(
    '[Perm Offer Effect] Fetch Perm Offer Declined Removal Reasons Failure'
);

export const fetchJobBillRateSuccess = createAction(
    '[Perm Offer Effect] Fetch Job Bill Rate Success',
    props<PostOfferJobInformationPayload>()
);

export const fetchJobBillRateFailure = createAction(
    '[Perm Offer Effect] Fetch Job Bill Rate Failure'
);

export const fetchPermPostOfferDataSuccess = createAction(
    '[Perm Offer Effect] Fetch Perm Post Offer Data Success',
    props<PostOfferInformationSerializable>()
);

export const fetchPermPostOfferDataFailure = createAction(
    '[Perm Offer Effect] Fetch Perm Post Offer Data Failure'
);

export const updateOfferInfoAndSubmittalStatusFailure = createAction(
    '[Perm Offer Effect] Update Offer Info and Submittal Status Failure'
);

export const clearPostOfferState = createAction(
    '[Perm Offer Effect] Clear Post Offer State'
);
